/**
 * @desc 创建报警规则(旧版)
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.AlertCreateRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/alert/rule/create',
    data,
  });
}

export function mock(
  data: defs.AlertCreateRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/alert/rule/create',
    data,
  });
}
